import { render, staticRenderFns } from "./StepAccessTicketConfirmation.vue?vue&type=template&id=b8185662&"
import script from "./StepAccessTicketConfirmation.vue?vue&type=script&lang=ts&"
export * from "./StepAccessTicketConfirmation.vue?vue&type=script&lang=ts&"
import style0 from "./StepAccessTicketConfirmation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VChip,VCol,VForm,VIcon,VImg,VRow})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8185662')) {
      api.createRecord('b8185662', component.options)
    } else {
      api.reload('b8185662', component.options)
    }
    module.hot.accept("./StepAccessTicketConfirmation.vue?vue&type=template&id=b8185662&", function () {
      api.rerender('b8185662', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tickets/tickets-form/access/StepAccessTicketConfirmation.vue"
export default component.exports